/**
 * @ignore
 * Created by Shanie on 12/15/16.
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import QueryLookupRenderer from 'relay-query-lookup-renderer';
import rootQuery from '../queries/favoritesRoot';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { connect } from 'react-redux';

import { sortBy, tabs } from './constants';

// Helpers
import SV from 'server-vars';
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { addLoginHandlers } from 'dibs-buyer-layout/src/entries/index';

// Components
import Error from './components/Error';
import Loader from './components/Loading';
import FavoritesContainer from './components/FavoritesContainer';

function FavoritesRenderer(props) {
    const {
        first,
        portfolioDoesNotExist,
        portfolioIds,
        portfolioViewPermission,
        portfolioTypes,
        projectId,
        searchTerm,
        showSeller,
        tab,
        page,
        readyToRender,
    } = props;

    const [userData, setUserData] = useState({
        isTrade: props.isTrade,
        userId: props.userId,
    });

    useEffect(() => {
        addLoginHandlers(() =>
            setUserData({
                userId: getBuyerId(document.cookie),
                isTrade: getUserType(document.cookie) === 'trade',
            })
        );
    }, []);

    const { userId, isTrade } = userData || {};
    const isFolder = tab === tabs.FOLDER && !!portfolioViewPermission;
    const isProject = tab === tabs.PROJECT;
    const variables = {
        after: null,
        first,
        hasUserId: !!userId,
        portfolioIds: portfolioIds && portfolioIds.length ? portfolioIds : null,
        portfolioTypes: portfolioTypes.length ? portfolioTypes : null,
        projectId,
        searchTerm,
        sortBy: sortBy.CUSTOM,
        foldersSort: sortBy.CUSTOM,
        loadPortfolioData: !!userId,
        selectedItemIds: [],
        userId,
        userIds: [userId],
        useProjectEndpoint: !!projectId,
        isDiscover: tab === tabs.DISCOVER,
        isItems: tab === tabs.ITEMS,
        isFolders: tab === tabs.FOLDERS,
        isFollowing: tab === tabs.FOLLOWING,
        isSinglePortfolio: isFolder || isProject,
        isProjects: tab === tabs.PROJECTS,
        isTrade,
        showSeller,
        tab,
        page,
    };

    if (!readyToRender) {
        return null;
    }

    const environment = getRelayEnvironment(SV.get('favorites.records'));

    return (
        <QueryLookupRenderer
            lookup
            retain
            environment={environment}
            query={rootQuery}
            variables={variables}
            render={({ error, props: relayProps }) => {
                if (error) {
                    return <Error />;
                } else if (relayProps) {
                    return (
                        <FavoritesContainer
                            {...variables}
                            {...relayProps}
                            portfolioDoesNotExist={portfolioDoesNotExist}
                        />
                    );
                } else {
                    return <Loader partialPageLoading />;
                }
            }}
        />
    );
}

FavoritesRenderer.propTypes = {
    first: PropTypes.number,
    isTrade: PropTypes.bool,
    portfolioDoesNotExist: PropTypes.bool,
    portfolioIds: PropTypes.array,
    portfolioTypes: PropTypes.array,
    portfolioViewPermission: PropTypes.bool,
    projectId: PropTypes.string,
    showSeller: PropTypes.bool,
    tab: PropTypes.string,
    userHasChanged: PropTypes.bool,
    userId: PropTypes.string,
    searchTerm: PropTypes.string,
    page: PropTypes.number,
    readyToRender: PropTypes.bool,
};

const mapStateToProps = state => {
    return {
        portfolioDoesNotExist: state.favorites.uiState.portfolioDoesNotExist,
        portfolioIds: state.favorites.uiState.portfolioIds,
        portfolioViewPermission: state.favorites.uiState.portfolioViewPermission,
        portfolioTypes: state.favorites.uiState.portfolioTypes,
        projectId: state.favorites.uiState.projectId,
        tab: state.favorites.uiState.tab,
        userHasChanged: state.favorites.uiState.userHasChanged,
        readyToRender: state.favorites.uiState.readyToRender,
    };
};

export default connect(mapStateToProps)(FavoritesRenderer);
